(function () {
    function equalizeSlideHeights() {
        let maxHeight = 0;
        let $featuredLocationsSliderWithBtns = $('.module-featured-locations-with-buttons__featured-locations-wrapper');

        const $slides = $featuredLocationsSliderWithBtns.find('.module-featured-locations-with-buttons__featured-location');

        // Reset heights
        $slides.css('height', 'auto');

        // Find the tallest slide
        $slides.each(function () {
            maxHeight = Math.max(maxHeight, $(this).outerHeight());
        });

        // Set all slides to the tallest height
        $slides.css('height', maxHeight + 'px');
    }

    function equalizeSimpleSliderHeights() {
        let maxHeight = 0;
        const $slider = $('.module-simple-slider-boxes__slider');
        const $slides = $slider.find('.module-simple-slider-boxes__slider__single');

        // Reset heights
        $slides.css('height', 'auto');
        $slides.find('.module-simple-slider-boxes__slider__single__inner-wrapper').css('height', 'auto');

        // Find the tallest slide
        $slides.each(function () {
            const $innerWrapper = $(this).find('.module-simple-slider-boxes__slider__single__inner-wrapper');
            maxHeight = Math.max(maxHeight, $innerWrapper.outerHeight());
        });

        // Set all slides to the tallest height
        $slides.find('.module-simple-slider-boxes__slider__single__inner-wrapper').css('height', maxHeight + 'px');
    }

    function initSlider() {
        let $featuredLocationsSliderWithBtns = $('.module-featured-locations-with-buttons__featured-locations-wrapper');
        let slideCount = $featuredLocationsSliderWithBtns.children().length;
        if (!$featuredLocationsSliderWithBtns.length) {
            return;
        }
        let $packagesSection = $('.module-packages-section__tabs__content__single__content-wrapper');
        $featuredLocationsSliderWithBtns.slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 300,
            adaptiveHeight: false,
            responsive: [
                {
                    breakpoint: 9999,
                    settings: slideCount > 1 ? {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        margin: 48,
                        centerMode: false,
                        centerPadding: '0px'
                    } : "unslick"
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: false,
                        centerPadding: '0px'
                    }
                }
            ]
        });

        // Add margin to slides on desktop
        if (window.innerWidth > 768 && slideCount > 1) {
            if ($packagesSection.length) {
                $featuredLocationsSliderWithBtns.find('.slick-slide').css('margin-right', '30px');
            } else {
                $featuredLocationsSliderWithBtns.find('.slick-slide').css('margin-right', '46px');
            }
        }

        // Equalize heights after slider initialization
        equalizeSlideHeights();
    }

    function initSimpleSlider() {
        if (!$('.module-simple-slider-boxes__slider').length) {
            return;
        }
        let slideCount = $('.module-simple-slider-boxes__slider').children().length;
        $('.module-simple-slider-boxes__slider').slick({
            dots: true,
            arrows: true,
            infinite: true,
            speed: 300,
            adaptiveHeight: false,
            responsive: [
                {
                    breakpoint: 9999,
                    settings: slideCount > 4 ? {
                        slidesToShow: 5,
                        slidesToScroll: 1,
                        centerMode: false,
                        centerPadding: '0px'
                    } : "unslick"
                },
                {
                    breakpoint: 1920,
                    settings: slideCount > 3 ? {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        centerMode: false,
                        centerPadding: '0px'
                    } : "unslick"
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: false,
                        centerPadding: '0px'
                    }
                }
            ]
        }).on('init reInit afterChange', function () {
            equalizeSimpleSliderHeights();
        });

        // Call on window resize
        $(window).on('resize', _.debounce(equalizeSimpleSliderHeights, 150));
    }

    // Initialize on document ready
    $(document).ready(function () {
        initSlider();
        initSimpleSlider();

        $('.module-packages-section__tab').on('click', function () {
            let targetIndex = $(this).attr('data-tab-index');
            let targetClass = '.module-packages-section__tabs__content__single[data-tab-index="' + targetIndex + '"]';
            $('.module-packages-section__tab').removeClass('active');
            $(this).addClass('active');
            $('.module-packages-section__tabs__content__single').removeClass('active');
            $(targetClass).addClass('active');
            // Initialize slider after tab change
            if ($('.module-featured-locations-with-buttons__featured-locations-wrapper').hasClass('slick-initialized')) {
                $('.module-featured-locations-with-buttons__featured-locations-wrapper').slick('unslick');
            }
            initSlider();
        });

    });
    $('.module-faq-accordion-with-content__faq__single__question__icon').on('click', function () {
        console.log('clicked');
        $(this).parent().parent().toggleClass('active');
        $(this).parent().siblings('.module-faq-accordion-with-content__faq__single__answer').slideToggle();
    });
})();